export default function FeatureBubble({ src, alt, title }) {
    return (
        <div className="w-full md:w-[200px] h-auto md:h-[200px] bg-white p-10 rounded-lg md:rounded-full shadow-md shadow-slate-300/50 flex flex-row md:flex-col items-center justify-start md:justify-center gap-2 text-center animate-pulse">
          <img src={src} alt={alt} width={50} height="auto" className="w-[40px] md:w-[50px]" />
          <h3 className="poppins-medium text-slate-700 text-sm text-left md:text-center">{ title }</h3>
        </div>
    );
}